import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import DatosRegistroUsuarios from './datosUsuarios';
import { ROL_USER, USER_ID } from '../../../app/api-client/constants';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Años } from '../../domain/api/UsersApi';


export default function Registro() {
    const dispatch = useDispatch();

    const [, id_user] = localStorage.getItem(USER_ID)
    const [, rol] = localStorage.getItem(ROL_USER)
    const location = useLocation();
    const id = location.state?.id;
    const [Lista, setLista] = useState([]);

    //se consume el servicio para listar los años
    const ListAños = async () => {
      
        const dataList = await Años(dispatch);
        try {
            setLista(dataList.respuesta);

        } catch (err) {
            console.log("Ocurrio un error", err)
        }
    }


    useEffect(async () => {
        ;

        ListAños();

    }, [id]);

    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage={`Registro`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas"
                >
                    Home
                </MigaPan>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <DatosRegistroUsuarios
                    id={id}
                    Lista={Lista}>
                </DatosRegistroUsuarios>

            </Grid>

        </>
    );


}